const DEFAULT_RADIO_CLASS_NAME = 'default-radio';

export const RADIO_BORDER_HOVER_COLOR_VAR = '--radio-border-hover-color';
export const RADIO_CHECKED_BG_COLOR_VAR = '--radio-checked-bg-color';
export const RADIO_CHECKED_MAIN_COLOR_VAR = '--radio-checked-main-color';

export default DEFAULT_RADIO_CLASS_NAME;
